import APIClient from '@/shared/http/clients/api'

const resourceName = 'estado'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllByCountryID = (stateid, config = {}) => APIClient.get(`${APICore}/${resourceName}/pais/${stateid}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)

const StateRepository = {
  GetAll,
  GetAllPaging,
  GetAllByCountryID,
  GetById
}

export default StateRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/geo/state.js